<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>toc</v-icon>
            <v-toolbar-title class="font-weight-light">Grillas de Coeficientes de Planes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Nombre"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">
                        <tr @click="viewItem(item)">
                          <td class="text-xs-left">{{ item.nombre }}</td>
                          <td class="text-xs-left">{{ item.amortizacionDescripcion }}</td>

                          <td class="text-xs-left">                
                            <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                            <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon>

                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>table_chart</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-tooltip bottom  v-if="editMode">
                        <template v-slot:activator="{ on }">
                            <v-btn fab small top :color="$store.state.UiColors.crudToolbarDetailButtons" v-on="on" @click="guardarGrillaComo">
                              <v-icon  medium>file_copy</v-icon>
                            </v-btn>
                        </template>
                        <span>Copiar Grilla</span>
                      </v-tooltip>

                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">
                        <v-icon medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id>=0" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                          <v-layout>
                                <v-flex xs6>
                                  <v-text-field v-model="model.nombre" label="Nombre" required :disabled="!editMode" v-validate="'required'" data-vv-name="nombre" :error-messages="errors.collect('nombre')"></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                  <v-autocomplete v-model="model.amortizacionId" :items="sistemasAmortizacion" 
                                        item-text="descripcion" item-value="id" label="Sistema Amortización" placeholder="Seleccione" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                                </v-flex>
                          </v-layout>
                          
                          <v-switch v-model="ingresoPorRango" label="Ingresar por Rango de Cuotas" v-if="editMode"/>
                          <v-switch v-model="ayudaCarga" label="Ayuda de Carga" v-if="editMode"/>
                          <!-- <v-radio-group v-model="modoAyudaIngreso" :disabled="!editMode">
                                    <v-radio value="porRango">
                                      <div slot="label">Ingreso por Rango</div>
                                    </v-radio>
                                    <v-radio value="porCuotaEjemplo">
                                      <div slot="label">Ingreso por Cuota Ejemplo</div>
                                    </v-radio>
                          </v-radio-group> -->
                          

                          <v-container v-if="ingresoPorRango">
                            <v-row>
                              <v-textarea
                                v-if ="model.amortizacionId == 1"
                                height=20
                                value="A continuación puede ingresar un rango de cuotas y una tasa para generación automática de los registros de la tabla."
                                :disabled = 'true'
                              ></v-textarea>
                            </v-row>
                              <!-- ayuda de carga -->
                              <v-container v-if="ayudaCarga">
                                  <v-row>
                                      <v-col cols="4">
                                          <v-text-field v-model="valoresEjemplo.importeCuota" label="Obtener Cuota de" :disabled="!editMode"></v-text-field>
                                      </v-col>
                                      <v-col cols="4">
                                            <v-text-field v-model="valoresEjemplo.capital" label="Para un capital de" :disabled="!editMode"></v-text-field>
                                      </v-col>
                                      <v-col cols="3">
                                          <v-text-field v-model="valoresEjemplo.cuotas" label="En cuotas" :disabled="!editMode"></v-text-field>
                                      </v-col>
                                      <v-col cols="1">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn  icon small v-on="on" @click="calcularTasaConEjemplo"> <v-icon outlined color="green">monetization_on</v-icon></v-btn>
                                            </template>
                                            <span>Calcular Tasa</span>
                                        </v-tooltip>  
                                      </v-col>
                                  </v-row>                          
                              </v-container>
                              <v-row>
                                  <v-col>
                                      <v-text-field v-model="cuotasDesdeCalculo" label="Cuota Desde" :disabled="!editMode" v-if ="model.amortizacionId == 1"></v-text-field>
                                  </v-col>
                                  <v-col>
                                        <v-text-field v-model="cuotasHastaCalculo" label="Cuota Hasta" :disabled="!editMode" v-if ="model.amortizacionId == 1"></v-text-field>
                                  </v-col>
                                  <v-col>
                                      <v-text-field v-model="tasaCalculo" label="Tasa (Mensual)" :disabled="!editMode || ayudaCarga" v-if ="model.amortizacionId == 1"></v-text-field>
                                  </v-col>
                                  <v-col>
                                    <v-btn color="success" :disabled="!editMode" @click="generarCuotas" v-if ="model.amortizacionId == 1" right><v-icon>done</v-icon>Generar Cuotas</v-btn>
                                  </v-col>
                              </v-row>                          
                          </v-container>
                          
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                  <v-chip label :disabled="!editMode"> 
                                    TNA: {{TNA}}%
                                    <v-icon right v-on="on" outlined >info</v-icon>
                                  </v-chip>
                              </template>
                              <span>Este valor se calcula una vez guardada la grilla</span>
                          </v-tooltip>  
                          <!-- <v-chip label >
                            
                          </v-chip> -->
                          <!-- <v-row>
                            <v-col cols="3">
                          
                            </v-col>
                           </v-row>-->
                          <app-lista-tasas propName= "listaCoeficientes" :value="model.coeficientes" :editMode="editMode"></app-lista-tasas>

                          <template v-if="$store.state.debugModeOn"> 
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                            ValoresEjemplo: {{valoresEjemplo}}  <p></p>
                            TNA: {{TNA}}                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!editMode" @click="saveItem" right><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>

                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import {Decimal} from 'decimal.js';

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Tabla', value: 'nombre' },
        { text: 'Amortización', value: 'sistemaAmortizacion' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      sistemasAmortizacion: [],
      model: {coeficientes:[] }, // registro para ver/editar
      cuotasDesdeCalculo:0,
      cuotasHastaCalculo:0,
      tasaCalculo:0,
      ingresoPorRango: false,
      ayudaCarga: false,
      valoresEjemplo:{capital:0,cuotas:0,importeCuota:0},
      TNA:0
    };
  },
  async created() {
    this.loadSistemasAmortizacion();     
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    } 
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {
        var result = await http.get('tablasCoeficientes?nombre='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false') );     

        this.records = result.list;
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      
      this.loading = true
      this.resetState()

      try {
        var result = await http.get('tablasCoeficientes/' +id );
        
        this.model = result;
        this.cuotasDesdeCalculo = 0;
        this.cuotasHastaCalculo = 0;
        this.tasaCalculo = 0;
        this.TNA = Math.round((this.model.tna + Number.EPSILON) * 100) / 100;
        Vue.$log.debug(this.TNA);
        Vue.$log.debug(this.model);

} catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    guardarGrillaComo(){
      this.model.id = 0;
      this.model.nombre = '';
      this.alertSuccess('La grilla se copio en una nueva. Puede ingresar otro nombre, modificar los datos necesarios y guardarla como una grilla nueva.')
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {coeficientes:[]}
        this.cuotasDesdeCalculo = 0;
        this.cuotasHastaCalculo = 0;
        this.tasaCalculo = 0;
        this.TNA = 0;
        this.valoresEjemplo={};
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      
      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0) return;

      if(!this.validarTasas()) return;

      if (isUpdate) {
        try{
          await http.put('tablasCoeficientes', JSON.stringify( {tabla:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }               
      } else {
        try{
          await http.post('tablasCoeficientes', JSON.stringify( {tabla:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          Vue.$log.error(error);
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación de la Tabla ' + item.nombre + '?')) {
        try{
            var result = await http.delete('tablasCoeficientes?id='+item.id );
            this.alertSuccess('La tabla ha sido eliminada.')
            this.clearAndReload();
        }
        catch(error){
            //Error
            Vue.$log.error(error);
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('La Tabla no puede ser eliminada debido a que está asociada a uno o más planes.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    async loadSistemasAmortizacion() {
        this.loading = true
        try {
            var result = await http.get('tipossistemaamortizacion');
            this.sistemasAmortizacion = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
    },
    generarCuotas(){
      if(isNaN(this.cuotasDesdeCalculo) || isNaN(this.cuotasHastaCalculo) || this.cuotasDesdeCalculo==0 || this.cuotasHastaCalculo == 0)
      {
        this.alertError('Por favor, verifique el valor ingresado en los campos Cuotas Desde/Hasta.')
        return;
      }

      if (parseInt(this.cuotasDesdeCalculo) > parseInt(this.cuotasHastaCalculo))
      {
        this.alertError('Verifique que el campo Cuota Desde no sea mayor a Cuota Hasta.')
        return;
      }
      
      if (isNaN(this.tasaCalculo) || this.tasaCalculo == 0)
      {
        this.alertError('Por favor, verifique el valor ingresado en en campo Tasa.')
        return;
      }

      if (!confirm('¿Confirma la generación de la tabla entre ' + this.cuotasDesdeCalculo +  ' y ' + this.cuotasHastaCalculo + 
                  ' cuotas con una Tasa del ' + this.tasaCalculo +' Mensual?')) {
                    return;
      }
      
      this.model.coeficientes = [];
      var desde = parseInt(this.cuotasDesdeCalculo);
      var hasta = parseInt(this.cuotasHastaCalculo);
      for (var i = desde; i <= hasta; i++)
      {
          let tasaInteres = new Decimal(this.tasaCalculo).times(i);
          this.model.coeficientes.push({cuotas: i,coeficiente:tasaInteres.toFixed(4)});
      }
    },
    validarTasas(){
      Vue.$log.debug(this.model.coeficientes);

      if(this.model.coeficientes.length == 0)
      {
        this.alertError('La lista de tasas no puede estar vacía.');
        return false;
      }

      var coeficientesOrdenados = this.model.coeficientes.sort(function (a, b) { return a.cuotas - b.cuotas;});

      let cuotaAnterior=coeficientesOrdenados[0].cuotas;

      for(var i = 1; i < coeficientesOrdenados.length ;i++){
        if(cuotaAnterior == coeficientesOrdenados[i].cuotas)
        {
          this.alertError('La cuota ' + cuotaAnterior + ' está repetida. Por favor verifique.')
          return false;
        }
        cuotaAnterior = coeficientesOrdenados[i].cuotas;
      }

      return true;
    },
    calcularTasaConEjemplo(){
        var importeCuota = parseFloat(this.valoresEjemplo.importeCuota);
        var capital = parseFloat(this.valoresEjemplo.capital);
        var cuotas = parseInt(this.valoresEjemplo.cuotas);

        if(isNaN(importeCuota) || isNaN(capital) || isNaN(cuotas))
        {
          this.alertWarning('Alguno de los valores ingresados para el cálculo son incorrectos. Verifique.')
          return;
        }

        var tasa = (((cuotas * importeCuota - capital) / capital / cuotas) * parseFloat(100));

        this.tasaCalculo = Math.round((tasa + Number.EPSILON) * 100) / 100;

        this.calcularTNA(this.tasaCalculo);
    },
    async calcularTNA(tasaMensual){

    }
  },
  generarReporte(){

  }
}
</script>